import {
  type BlockItemRenderers,
  blockRenderers,
  CustomComponentRenderer,
  WebForm,
  CForm,
  BraidComponent,
  BugcrowdForm,
} from '@seek/cmsu-components';
import type { FormFragment, WebFormFragment } from '@seek/cmsu-cms-connect';
import { useConfig } from 'src/client/shared/hooks';
import { LatestArticlesByCategoryLoader } from '../client/components/modules/LatestArticlesByCategory/LatestArticlesByCategoryLoader';
import { WPT_SALESFORCE_API } from '../config';
import { getPrivacyLink } from './form';
import { SearchBoxWrapper } from 'src/client/components/SearchBoxWrapper/SearchBoxWrapper';

type WebFormProps = Pick<
  WebFormFragment,
  'formType' | 'document' | 'confirmationMessage' | 'webFormColumns'
>;

export const pageRenderers: BlockItemRenderers = {
  ...blockRenderers.hirer,
  CCustomComponent: ({ data }, additionalData) => {
    const { country, melwaysLocale, sourceName, privacyUrl, recaptchaKey } =
      useConfig();

    return data ? (
      <CustomComponentRenderer
        data={data}
        renderers={{
          ...blockRenderers.customComponentRenderers,
          SearchBox: () => <SearchBoxWrapper />,
          WebForm: ({
            document,
            formType,
            confirmationMessage,
            webFormColumns,
          }: WebFormProps) => (
            <WebForm
              country={country}
              locale={melwaysLocale}
              privacyUrl={privacyUrl}
              sourceName={sourceName}
              recaptchaKey={recaptchaKey}
              columns={webFormColumns}
              formType={formType}
              confirmationMessage={confirmationMessage?.raw}
              document={document?.url}
              wptSalesForceApi={WPT_SALESFORCE_API}
              privacyLink={getPrivacyLink(melwaysLocale)}
            />
          ),
          CForm: ({ form }) => (
            <CForm
              locale={melwaysLocale}
              sourceName={sourceName}
              privacyUrl={privacyUrl}
              recaptchaKey={recaptchaKey}
              wptSalesForceApi={WPT_SALESFORCE_API}
              country={country}
              form={form as FormFragment}
            />
          ),
          BraidComponent: ({ braidCode }) => (
            <BraidComponent braidCode={braidCode} />
          ),
          BugcrowdForm: () => <BugcrowdForm />,
        }}
        additionalData={additionalData}
      />
    ) : null;
  },
  LatestArticlesByCategory: ({ category }) => (
    <LatestArticlesByCategoryLoader categorySlug={category?.slug} />
  ),
};
